export default __webpack_public_path__ + "static/media/yo8.820b6ff7.png";